import { useEffect, useState } from "react"
import { Form, Button, Row, Col} from "antd"
import { useSelector, useDispatch } from "react-redux"
import { MyInput, MySelect } from "../../../Forms"
import { actionsApi } from "../../../../shared"
import { methodAllow, roles, yesNo } from "../../../../shared/lookups"
import { useTranslation } from "react-i18next"
import { t } from "i18next"
let timer

const Filter= ()=>{

    const dispatch= useDispatch()
    const [form] = Form.useForm()
    const {pagination, masterVendorLookup, vendorUserLookup, filters} = useSelector(state => state?.addEditBox)
    const vendorUserData = useSelector(state => state?.vendorUser?.data) || [];
    const masterVendorOptions = [{ id: '', name: 'Tüm Vendorlar' }, ...vendorUserData.map(v => ({ id: v.id, name: v.name }))]
    const [isNotAdmin, setIsNotAdmin]= useState(false)
    
    const getRole = () => {
        try {
            const user = JSON.parse(localStorage.getItem("user"))
            return user?.role || ''
        } catch (error) {
            console.error('Role alınırken hata oluştu:', error)
            return ''
        }
    }
    
    const role = getRole()
    
    useEffect(()=>{
        if(role==='masterAdmin' && (!vendorUserData || vendorUserData.length === 0)){
            dispatch(actionsApi?.getAllVendorUser({ pageNo: 1, pageSize: 100, role: 'masterAdmin' }))
        }
    }, [vendorUserData, role, dispatch])
    useEffect(()=>{
        dispatch(actionsApi?.viewAllAndroidBoxes({pageNo: 1, pageSize: pagination?.pageSize}))
    },[])

    const prepareData= ()=>{
        let data = form.getFieldsValue()
        const {masterVendorId, vendorUserId}= data
        if(role === 'masterAdmin' && masterVendorId){
            if(masterVendorId !== ''){
                data.userID = masterVendorId
            } else {
                delete data.userID
            }
            delete data.androidBoxAddedFor
        }
        else if(data.androidBoxAddedFor===3 && vendorUserId){
            data.userID= vendorUserId
            delete data.androidBoxAddedFor
        }
        else if(data.androidBoxAddedFor===2 && masterVendorId){
            data.userID= masterVendorId
            delete data.androidBoxAddedFor
        }
        else if(masterVendorId && masterVendorId !== ''){
            data.userID= masterVendorId
        }
        else
            delete data.userID
        return data
    }
    const filter = () => {
        let data = prepareData()
        dispatch(actionsApi?.viewAllAndroidBoxes({ ...data, pageNo: 1, pageSize: pagination?.pageSize}))
        dispatch(actionsApi?.setFilters(data))
        dispatch(actionsApi?.setPages({pageNo: 1, pageSize: pagination?.pageSize, totalRecords: pagination?.totalRecords}))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(filter, 400)
    function handlePagination(pageNo=1, pageSize=20) {
        let data= prepareData()
        dispatch(actionsApi?.viewAllAndroidBoxes({...data, pageNo, pageSize}))
    }

    return (
        <>
            <Form
                form={form}
                layout="vertical"
            >
                <Row gutter={[16, 0]}>
                    <Col span={6}>
                        <MyInput
                            name='customerName'
                            label= {t("Customer Name")}
                            placeholder='e.g John Doe'
                            onChange={debouncedSearchHandler}
                        />
                    </Col>
                    <Col span={6}>
                        <MyInput
                            label= {t("Mac Address")}
                            name=  'macAddress'
                            placeholder='e.g 00:B0:D0:63:C2:46'
                            onChange={(e) => {
                                const inputValue = e.target.value;
                                const cleanedValue = inputValue.replace(/\W/g, '');
                                const formattedMacAddress = cleanedValue.match(/.{1,2}/g)?.join(':').slice(0, 17) || '';
                                form.setFieldsValue({ ...form?.getFieldsValue(), macAddress: formattedMacAddress })
                                debouncedSearchHandler()
                            }} 
                        />
                    </Col>
                    <Col span={6}>
                        <MyInput
                            name='boxName'
                            label= {t("Box Name")}
                            placeholder='e.g Box 1002'
                            onChange={debouncedSearchHandler}
                        />
                    </Col>
                    {
                        role === 'masterAdmin' ?
                        <Col span={6}>
                            <MySelect
                                label= {t("Role")}
                                name="androidBoxAddedFor" 
                                placeholder='select...'
                                options={roles}
                                onChange= {(value)=>{
                                    if(value===2 || value ===3)
                                        setIsNotAdmin(value)
                                    else
                                        setIsNotAdmin(false)
                                    filter()

                                }}
                                allowClear
                            />
                        </Col>
                        :""
                    }
                    <Col span={6}>
                        <MySelect
                            label= 'Master vendor'
                            name="masterVendorId" 
                            placeholder='select...'
                            options={masterVendorOptions}
                            onChange= {filter}
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        />
                    </Col>
                    {
                        isNotAdmin===3 &&
                        <Col span={6}>
                            <MySelect
                                label= 'Vendor user'
                                name="vendorUserId" 
                                placeholder='select...'
                                options={vendorUserLookup}
                                onChange= {filter}
                                allowClear
                            />
                        </Col>
                    }
                    <Col span={6}>
                        <MySelect
                            label= {t("Update Url")}
                            name="updateUrl" 
                            placeholder='select...'
                            options={methodAllow}
                            onChange= {filter}
                            allowClear
                        />
                    </Col>
                    <Col span={6}>
                        <MySelect
                            label= 'Master portal'
                            name="masterPortal" 
                            placeholder='select...'
                            options={yesNo}
                            onChange= {filter}
                            allowClear
                        />
                    </Col>
                </Row>
            </Form>
        </>
    )
}
export {Filter}